<template>
  <div :class="hideSelectAll?'hide-select-all':''">
    <Table border stripe :max-height="tableHeight" size="small" :row-class-name="rowClassName"
           :columns="getTableColumns"
           :loading="loading"
           :data="showTableList[theDb]"
           ref="filterBody">
      <template #selection="{ row }">
        <Poptip trigger="hover" :title="$t('wu-fa-xuan-zhong-yuan-yin')" v-if="row._disabled" transfer>
          <template #content>
            <div v-for="msg in row.disabledMsgArr" :key="msg">{{msg}}</div>
          </template>
          <Checkbox v-model="row._checked" @on-change="handleSelectionChange($event, row)" :disabled="row._disabled"/>
        </Poptip>
        <Checkbox v-model="row._checked" @on-change="handleSelectionChange($event, row)" :disabled="row._disabled" v-else/>
      </template>
      <template #sourceTable="{ row }">
        <div :style="taskInfo.newData[db.sourceDb] && taskInfo.newData[db.sourceDb].selectedTables[row.sourceTable] ? 'color: green;font-weight: bold' :
        taskInfo.reduceData[db.sourceDb] && taskInfo.reduceData[db.sourceDb].selectedTables[row.sourceTable] ? 'color: red;font-weight: bold' : ''" v-if="taskInfo.processType === 'edit'">
          {{row.sourceTable}}
        </div>
        <div v-else>
          {{row.sourceTable}}
        </div>
      </template>
      <template slot-scope="{ row }" slot="action">
        <div style="text-align: left">
          <CheckboxGroup v-if="selectedTables[theDb]"
                         v-model="selectedTables[theDb][row.index].action"
                         @on-change="handleActionChange(selectedIndex,db,row,selectedTables[theDb][row.index].action)">
            <Checkbox v-for="action in DML" :key="action" style="width: 75px" :label="action" :disabled="tableDisabled || !selectedTables[theDb][row.index].selected">
              <span :style="`${
                row.originalAction && row.action.includes(action) && !row.originalAction.includes(action) ? 'color: green;font-weight: bold;' :
                  row.originalAction && !row.action.includes(action) && row.originalAction.includes(action) ? 'color: red;font-weight: bold;' : 'color: black'
              }`">{{action}}</span>
            </Checkbox>
            <div v-for="action in DDL" :key="action" style="display: inline-block">
              <Checkbox style="min-width: 75px" v-if="!JSON.parse(taskInfo.ddl) && DataSourceGroup.ddlFilter.includes(taskInfo.sourceType) && (action !== 'DROP' || (action === 'DROP' && isMySQL(taskInfo.sourceType) && isMySQL(taskInfo.sinkType)))"
                        :label="action" :disabled="tableDisabled || !selectedTables[theDb][row.index].selected">
                <span :style="`${
                row.originalAction && row.action.includes(action) && !row.originalAction.includes(action) ? 'color: green;font-weight: bold;' :
                  row.originalAction && !row.action.includes(action) && row.originalAction.includes(action) ? 'color: red;font-weight: bold;' : 'color: black'
              }`">{{action}}</span>
              </Checkbox>
            </div>
          </CheckboxGroup>
        </div>
      </template>
      <template slot-scope="{ row }" slot="sink">
        <div v-if="row.selected" style="display: flex;align-items: center;">
          <div v-if="selectIndex===row.index&&!row._disabled" style="flex: 1">
            <Select filterable v-if="selectedTables[theDb]&&row.selected"
                    v-model="selectedTables[theDb][row.index].sinkTable" :disabled="tableDisabled"
                    @on-change="handleSelectChange(selectedIndex,theDb,row,$event)"
                    :class="dbToCreateClass(db,row)" allow-create @on-create="handleCreate1(theDb, row, $event)"
                    style="width:100%" :transfer="true" ref="sink-select">
              <Option v-for="(item) in getSinkList(theDb, row)" :value="item.tableName"
                      :key="item.tableName">{{ item.tableName }}
              </Option>
              <Option v-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)===-1&&DataSourceGroup.mq.indexOf(taskInfo.sourceType)===-1 && taskInfo.editType !== '2'&&
                    (selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row), selectedTables[theDb][row.index].sinkTable)"
                      :value="selectedTables[theDb][row.index].sinkTable">
                {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
              </Option>
              <Option v-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&& taskInfo.editType !== '2'&&
                    migrationType==='table'&&(selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row),selectedTables[theDb][row.index].sinkTable)"
                      :value="selectedTables[theDb][row.index].sinkTable">
                {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
              </Option>
              <Option v-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&&
                    migrationType==='db'&& taskInfo.editType !== '2'&&
                    !topicName&&
                    (selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row),selectedTables[theDb][row.index].sinkTable)"
                      :value="getTargetName(theMappingRule[theMappingIndex],theDb,selectedTables[theDb][row.index],taskInfo)">
                {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
              </Option>
              <Option v-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&& taskInfo.editType !== '2'&&
                    !!topicName&&
                    (selectedTables[theDb][row.index].sinkTable)&&!containsTable(getSinkList(theDb, row),topicName)"
                      :value="topicName">{{ $t('topicname-dai-chuang-jian', [topicName]) }}
              </Option>
            </Select>
          </div>
          <div @mouseover="displaySelect(row.index)" v-else style="flex: 1">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div>
                <div v-if="isExistedDb(theDb, selectedTables[theDb][row.index].sinkTable, row)">
                  {{selectedTables[theDb][row.index].sinkTable}}
                </div>
                <div v-else-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)===-1&&DataSourceGroup.mq.indexOf(taskInfo.sourceType)===-1&& taskInfo.editType !== '2'&&
                    (selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row),selectedTables[theDb][row.index].sinkTable)"
                     style="color: #FF6E0D;">
                  {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
                </div>
                <div v-else-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&& taskInfo.editType !== '2'&&
                    migrationType==='table'&&(selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row),selectedTables[theDb][row.index].sinkTable)"  style="color: #FF6E0D;">
                  {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
                </div>
                <div v-else-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&& taskInfo.editType !== '2'&&
                    migrationType==='db'&&
                    !topicName&&
                    (selectedTables[theDb][row.index].sinkTable)&&
                    !containsTable(getSinkList(theDb, row),selectedTables[theDb][row.index].sinkTable)"  style="color: #FF6E0D;">
                  {{ $t('gettargetvalueselectedcolumnstablesourcedbtablesourcetablerowindexsourcecolumn-dai-chuang-jian', [selectedTables[theDb][row.index].sinkTable]) }}
                </div>
                <div v-else-if="DataSourceGroup.mq.indexOf(taskInfo.sinkType)>-1&& taskInfo.editType !== '2'&&
                    !!topicName&&
                    (selectedTables[theDb][row.index].sinkTable)&&!containsTable(getSinkList(theDb, row),topicName)"  style="color: #FF6E0D;">
                  {{ $t('topicname-dai-chuang-jian', [topicName]) }}
                </div>
                <div v-else style="color: #ccc">
                  {{ $t('qing-xuan-ze') }}
                </div>
              </div>
              <Icon type="ios-arrow-down" size="14" color="#808695"/>
            </div>
          </div>
          <Tooltip v-if="row.sinkTable !== row.originalSinkTable && taskInfo.processType === 'edit' && row.hasInJob" style="margin-left: 10px;" transfer>
            <Icon type="ios-information-circle-outline" />
            <div slot="content">
              {{row.originalSinkTable}}
            </div>
          </Tooltip>
        </div>
      </template>
      <template slot="shards" slot-scope="{row}">
        <div v-if="row.selected">
          <p style="margin-left: 7px" v-if="!row.needAutoCreated">{{ row.shards }}</p>
          <Input v-if="row.needAutoCreated" v-model="selectedTables[theDb][row.index].shards"
                 @change="handleChangeShards(selectedIndex,theDb,row,$event)"
                 :placeholder="$t('qing-shu-ru-fen-pian-shu')"></Input>
        </div>
      </template>
      <template slot="replication" slot-scope="{row}">
        <div v-if="row.selected">
          <p style="margin-left: 7px" v-if="!row.needAutoCreated">{{ row.replication }}</p>
          <Input v-if="row.needAutoCreated" v-model="selectedTables[theDb][row.index].replication"
                 @change="handleChangeReplication(selectedIndex,theDb,row,$event)"
                 :placeholder="$t('qing-shu-ru-fen-pian-fu-ben-shu')"></Input>
        </div>
      </template>
    </Table>
    <div class="page-footer-paging table-filter-footer" style="padding-left: 20px">
      <div>
        <Checkbox v-model="taskInfo.dbMap[selectedIndex].selectedPage" :indeterminate="taskInfo.dbMap[selectedIndex].indeterminate" @on-change="handleSelectAllCheck" :disabled="taskInfo.schemaWhiteListLevel === 'DB'"><span style="margin-left: 4px">{{$t('quan-bu-xuan-zhong')}}</span></Checkbox>
        <span style="font-weight: 500;margin-left: 20px">{{ $t('yi-xuan-zhong') }}<span style="color:#FF6E0D">{{getSelectedInfo(db.sourceDb).selectedCount}}</span>{{ $t('xiang-zong-gong-selectedtablesdbsourcedb-selectedtablesdbsourcedblength-0-xiang', [selectedTables[db.sourceDb] ? selectedTables[db.sourceDb].length : 0]) }}</span>
      </div>
      <Page size="small" :total="pageData[theDb]?pageData[theDb].total:0" show-elevator
            @on-page-size-change="handlePageSizeChange(theDb,$event)" :page-size-opts="pagesizeOpts"
            @on-change="handlePageChange(theDb,$event)" show-sizer
            :page-size="pageData[theDb]?pageData[theDb].size:20"/>
    </div>
  </div>
</template>
<script>
import { isMQ, isMySQL } from '@/utils';
import DataSourceGroup from '@/views/dataSourceGroup';
import store from '@/store';
import { mapState } from 'vuex';
import { getTargetName } from '../util';

export default {
  props: {
    taskInfo: Object,
    db: Object,
    loading: Boolean,
    showTableList: Object,
    handleSelect: Function,
    selectedIndex: Number,
    handleSelectCancel: Function,
    handleSelectAll: Function,
    handleSelectAllCancel: Function,
    handleActionChange: Function,
    selectedTables: Object,
    handleSelectChange: Function,
    topicName: String,
    handleChangeShards: Function,
    pageData: Object,
    handlePageChange: Function,
    handlePageSizeChange: Function,
    handleChangeReplication: Function,
    containsTable: Function,
    handleChooseIndex: Function,
    migrationType: String,
    handleFocus: Function,
    remoteMethod: Function,
    handleBlur: Function,
    updateShowTableList: Function,
    theMappingRule: Array,
    theMappingIndex: Number,
    tableDisabled: Boolean,
    hideSelectAll: Boolean,
    getSelectedInfo: Function
  },
  data() {
    return {
      DDL: ['CREATE', 'ALTER', 'RENAME', 'TRUNCATE', 'DROP'],
      DML: ['INSERT', 'UPDATE', 'DELETE'],
      selectIndex: -1,
      getTargetName,
      pagesizeOpts: [20,50,100],
      store,
      theDb: {},
      DataSourceGroup,
      tableHeight: 600,
      tableColumns: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.taskInfo.sinkType === 'RocketMQ' || this.taskInfo.sinkType === 'Kafka' ? this.$t('topic-ming-cheng') : this.$t('mu-biao-biao'),
          slot: 'sink'
        },
        {
          title: this.$t('action-guo-lv'),
          slot: 'action',
          width: 400,
          align: 'center'
        }
      ],
      tableColumnsOnlyFull: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.taskInfo.sinkType === 'RocketMQ' || this.taskInfo.sinkType === 'Kafka' ? this.$t('topic-ming-cheng') : this.$t('mu-biao-biao'),
          slot: 'sink'
        }
      ],
      tableEsColumns: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.$t('mu-biao-suo-yin-ming-cheng'),
          slot: 'sink'
        },
        {
          title: this.$t('fen-pian-shu'),
          key: 'shards',
          width: 90,
          slot: 'shards'
        },
        {
          title: this.$t('fen-pian-fu-ben-shu'),
          key: 'replication',
          width: 120,
          slot: 'replication'
        },
        {
          title: this.$t('action-guo-lv'),
          slot: 'action',
          width: 400,
          align: 'center'
        }
      ],
      tableEsColumnsOnlyFull: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.$t('mu-biao-suo-yin-ming-cheng'),
          slot: 'sink'
        },
        {
          title: this.$t('fen-pian-shu'),
          key: 'shards',
          width: 90,
          slot: 'shards'
        },
        {
          title: this.$t('fen-pian-fu-ben-shu'),
          key: 'replication',
          width: 120,
          slot: 'replication'
        }
      ],
      tableEsColumnsOnlyCheckAndRevive: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.$t('mu-biao-suo-yin-ming-cheng'),
          slot: 'sink'
        }
      ],
      tableRedisColumns: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.$t('cache-qian-zhui'),
          key: 'sinkTable'
        },
        {
          title: this.$t('action-guo-lv'),
          slot: 'action',
          width: 400,
          align: 'center'
        }
      ],
      tableRedisColumnsOnlyFull: [
        {
          width: 60,
          slot: 'selection',
          align: 'center',
          renderHeader: (h, params) => h('Checkbox', {
            props: {
              disabled: this.taskInfo.schemaWhiteListLevel === 'DB',
              value: this.taskInfo.dbMap[this.selectedIndex].selectedPage,
              indeterminate: this.taskInfo.dbMap[this.selectedIndex].pageIndeterminate
            },
            on: {
              'on-change': (e) => {
                this.handleCurrentPageChange(e);
              }
            }
          })
        },
        {
          title: this.$t('yuan-biao'),
          slot: 'sourceTable',
          tooltip: true
        },
        {
          title: this.$t('cache-qian-zhui'),
          key: 'sinkTable'
        }
      ]
    };
  },
  mounted() {
    let totalHeight = window.innerHeight;

    if (totalHeight < 720) {
      totalHeight = 720;
    }
    // eslint-disable-next-line no-undef
    $('.table-filter-container')
      .css('height', `${totalHeight - 300}px`);
    this.tableHeight = totalHeight - 413;
    if (this.taskInfo.sinkType === 'Kafka' || this.taskInfo.sinkType === 'RocketMQ') {
      this.tableHeight = totalHeight - 453;
    }
    if (DataSourceGroup.mq.includes(this.taskInfo.sourceType)) {
      this.theDb = this.db.sinkDb;
    } else {
      this.theDb = this.db.sourceDb;
    }
  },
  computed: {
    getTargetValue() {
      return (target) => {
        if (this.taskInfo.targetCaseSensitive === 'false') {
          return target.toLowerCase();
        }
        if (this.taskInfo) {
          if (this.taskInfo.commonRule === 'UpperCase') {
            return target.toUpperCase();
          }
          if (this.taskInfo.commonRule === 'LowerCase') {
            return target.toLowerCase();
          }
        }
        return target;
      };
    },
    getSinkList() {
      return (theDb, row) => {
        if (row && row.hasInJob) {
          return this.taskInfo.sinkTableList[theDb];
        }
        if (JSON.parse(this.taskInfo.reSchemaMigration)) {
          return [];
        }
        return this.taskInfo.sinkTableList[theDb];
      };
    },
    getTableColumns() {
      if (this.taskInfo.type === 'CHECK' || this.taskInfo.type === 'REVISE' || this.taskInfo.type === 'STRUCT_MIGRATION' || this.taskInfo.type === 'MIGRATION'
        && !this.taskInfo.mode.synchronize || DataSourceGroup.mq.includes(this.taskInfo.sourceType)) {
        if (this.taskInfo.sinkType === 'ElasticSearch') {
          if (this.taskInfo.type === 'CHECK' || this.taskInfo.type === 'REVISE') {
            return this.tableEsColumnsOnlyCheckAndRevive;
          }
          return this.tableEsColumnsOnlyFull;
        }
        if (DataSourceGroup.redis.includes(this.taskInfo.sinkType)) {
          return this.tableRedisColumnsOnlyFull;
        }
        return this.tableColumnsOnlyFull;
      }
      if (this.taskInfo.sinkType === 'ElasticSearch') {
        return this.tableEsColumns;
      }
      if (DataSourceGroup.redis.includes(this.taskInfo.sinkType)) {
        return this.tableRedisColumns;
      }
      return this.tableColumns;
    },
    hasPk() {
      return (db, row) => {
        let theDb = db.sourceDb;

        if (DataSourceGroup.mq.includes(this.taskInfo.sourceType)) {
          theDb = db.sinkDb;
        }

        return !this.selectedTables[theDb][row.index].selected
          || !this.selectedTables[theDb][row.index].isRds
          && !this.selectedTables[theDb][row.index].hasPk && !DataSourceGroup.mq.includes(this.taskInfo.sinkType);
      };
    },
    dbToCreateClass() {
      return (db, row) => {
        let theDb = db.sourceDb;

        if (DataSourceGroup.mq.includes(this.taskInfo.sourceType)) {
          theDb = db.sinkDb;
        }
        if (this.selectedTables[theDb][row.index].sinkTable && !this.containsTable(this.getSinkList(theDb, row), this.selectedTables[theDb][row.index].sinkTable)) {
          return 'db-to-create';
        }
        return '';
      };
    }
  },
  methods: {
    handleCurrentPageChange(e) {
      console.log(e);
      if (e) {
        this.taskInfo.dbMap[this.selectedIndex].selectCurrentPageAll = true;
        this.handleSelectAll(this.selectedIndex, this.theDb, 'current');
      } else {
        this.taskInfo.dbMap[this.selectedIndex].selectCurrentPageAll = false;
        this.handleSelectAllCancel(this.selectedIndex, this.theDb, 'current');
      }
    },
    handleSelectAllCheck(e) {
      if (e) {
        this.taskInfo.dbMap[this.selectedIndex].selectedAll = true;
        this.handleSelectAll(this.selectedIndex, this.theDb);
      } else {
        this.taskInfo.dbMap[this.selectedIndex].selectedAll = false;
        this.handleSelectAllCancel(this.selectedIndex, this.theDb);
      }
    },
    handleSelectionChange(e, row) {
      if (e) {
        this.handleSelect(row);
      } else {
        this.handleSelectCancel(row);
      }
    },
    getSelection() {
      return this.$refs.filterBody.getSelection();
    },
    isMySQL,
    isMQ,
    isExistedDb(theDb, name, row) {
      if (this.getSinkList(theDb, row)) {
        return this.getSinkList(theDb, row).findIndex((table) => table.tableName === name) > -1;
      }
      return false;
    },
    displaySelect(index) {
      this.selectIndex = index;
    },
    rowClassName(row) {
      if (row._isChecked) {
        return 'demo-table-info-row';
      }
      return '';
    },
    handleCreate1(theDb, row, data) {
      this.selectedTables[theDb][row.index].sinkTable = data.trim();
    }
  },
  watch: {
    db(val) {
      if (DataSourceGroup.mq.includes(this.taskInfo.sourceType)) {
        this.theDb = val.sinkDb;
      } else {
        this.theDb = val.sourceDb;
      }
    }
  }

};
</script>

<style lang="less" scoped>
.page-footer-paging {
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
